module.exports = __webpack_public_path__ + "static/media/29EUNOG5.43d8ab71.jpg";